module.exports = __webpack_public_path__ + "img/piggybank.ced0e349.svg";